import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imClientsFilter', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/filters/clients-filter/clients-filter.html'),
        controller: 'ClientsFilterController',
        controllerAs: 'ClientsFilterCtrl',
        bindings: {
            isFullWidth: '<', // boolean
            placeholder: '<',
            client: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/filters/clients-filter/clients-filter.component.ts